import React, { useEffect, useState } from "react";
import { ButtonHover } from "./ReuseableComp/ButtonHover";

const BottomActionBtn = ({ buttons = [] }) => {
  const [show, setShow] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;

      if (currentY > lastScrollY) {
        setShow(false); // scroll down
      } else {
        setShow(true); // scroll up
      }

      setLastScrollY(currentY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <div
      style={{
        transition: "transform 0.3s ease",
        transform: show ? "translateY(0)" : "translateY(100%)",
      }}
      className="actionBtns"
    >
      {buttons.map((btn, index) => (
        <ButtonHover key={index} text={btn.text} onClick={btn.onClick} />
      ))}
    </div>
  );
};

export default BottomActionBtn;
